(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-guide"] && !Shopify.designMode) return;
  try {
    
  class EchoCollectionStoryTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick(event) {
      const button = event.target.closest('[data-tab-button]');
      if (!button || !this.contains(button)) return;
      this.activate(button.dataset.tabButton);
    }

    handleKeydown(event) {
      const button = event.target.closest('[data-tab-button]');
      if (!button || !this.contains(button)) return;
      const index = this.buttons.indexOf(button);
      let nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.buttons.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.buttons.length) % this.buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.buttons.length - 1;
      if (nextIndex === index) return;
      event.preventDefault();
      const nextButton = this.buttons[nextIndex];
      this.activate(nextButton.dataset.tabButton, true);
    }

    handleBlockSelect(event) {
      const blockId = event.detail && event.detail.blockId;
      if (!blockId || !this.panels.some((panel) => panel.dataset.tabPanel === blockId)) return;
      this.activate(blockId);
    }

    activate(blockId, moveFocus = false) {
      const update = () => {
        this.buttons.forEach((button) => {
          const selected = button.dataset.tabButton === blockId;
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
          if (selected && moveFocus) button.focus();
        });
        this.panels.forEach((panel) => {
          const selected = panel.dataset.tabPanel === blockId;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }
  }

  if (!customElements.get('collection-story-tabs')) {
    customElements.define('collection-story-tabs', EchoCollectionStoryTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["echo-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('echo-featured-collection')) {
    customElements.define(
      'echo-featured-collection',
      class extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('scroll-carousel');
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');

          if (!this.rail) {
            return;
          }

          this.updateProgress = this.updateProgress.bind(this);
          this.loadMore = this.loadMore.bind(this);
          this.showPrevious = () => this.scrollByCard(-1);
          this.showNext = () => this.scrollByCard(1);
          this.rail.addEventListener('scroll', this.updateProgress, { passive: true });
          this.addEventListener('click', this.loadMore);
          this.previousButton?.addEventListener('click', this.showPrevious);
          this.nextButton?.addEventListener('click', this.showNext);
          new ResizeObserver(this.updateProgress).observe(this.rail);
          this.updateProgress();
        }

        disconnectedCallback() {
          if (this.rail) {
            this.rail.removeEventListener('scroll', this.updateProgress);
          }

          this.removeEventListener('click', this.loadMore);
          this.previousButton?.removeEventListener('click', this.showPrevious);
          this.nextButton?.removeEventListener('click', this.showNext);
        }

        scrollByCard(direction) {
          const card = this.rail.querySelector('.product-card');

          if (!card) {
            return;
          }

          const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          const directionFactor = document.dir === 'rtl' ? -1 : 1;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

          this.rail.scrollBy({
            left: (card.getBoundingClientRect().width + gap) * direction * directionFactor,
            behavior,
          });
        }

        async loadMore(event) {
          const button = event.target.closest('[data-featured-load-more]');

          if (!button || button.disabled) {
            return;
          }

          const card = button.closest('[data-featured-load-more-card]');
          const status = card?.querySelector('[data-featured-load-status]');
          const label = button.querySelector('span');
          const nextPage = Number(button.dataset.nextPage);

          if (!card || !nextPage) {
            return;
          }

          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          if (label) label.textContent = 'Loading jewellery…';
          if (status) status.textContent = '';

          try {
            const requestUrl = new URL(window.location.href);
            requestUrl.searchParams.set('section_id', this.closest('.shopify-section').id.replace('shopify-section-', ''));
            requestUrl.searchParams.set('page', String(nextPage));

            const response = await fetch(requestUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });

            if (!response.ok) {
              throw new Error('Unable to load more products');
            }

            const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
            const responseRail = responseDocument.querySelector('[data-featured-collection-rail]');
            const newProducts = responseRail ? Array.from(responseRail.querySelectorAll(':scope > product-card')) : [];
            const nextCard = responseRail?.querySelector('[data-featured-load-more-card]');

            if (newProducts.length === 0) {
              throw new Error('No more products were found');
            }

            const fragment = document.createDocumentFragment();
            newProducts.forEach((productCard) => fragment.appendChild(document.importNode(productCard, true)));

            if (nextCard) {
              fragment.appendChild(document.importNode(nextCard, true));
            }

            card.replaceWith(fragment);
            this.updateProgress();
          } catch (error) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            if (label) label.textContent = 'Try again';
            if (status) status.textContent = 'We could not load more jewellery. Please try again.';
          }
        }

        updateProgress() {
          const maximumScroll = this.rail.scrollWidth - this.rail.clientWidth;
          const progress = maximumScroll > 0 ? this.rail.scrollLeft / maximumScroll : 1;
          this.style.setProperty('--echo-featured-progress', Math.max(0.12, progress));
          this.previousButton?.toggleAttribute('disabled', this.rail.scrollLeft <= 2);
          this.nextButton?.toggleAttribute('disabled', this.rail.scrollLeft >= maximumScroll - 2);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["echo-gift-card-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('echo-gift-card-selector')) {
    customElements.define('echo-gift-card-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        const variantInput = this.querySelector('[data-gift-card-variant]');
        const submitButton = this.querySelector('[data-gift-card-submit]');
        const rail = this.querySelector('[data-gift-card-value-rail]');
        const values = [...this.querySelectorAll('[data-gift-card-value]')];
        const choices = [...this.querySelectorAll('[data-gift-card-choice]')];
        const dots = [...this.querySelectorAll('[data-gift-card-dot]')];
        const mobileQuery = window.matchMedia('(max-width: 749px)');
        let scrollFrame;

        const setActiveChoice = (index, shouldScroll = false) => {
          const choice = choices[index];
          const value = values[index];

          if (!choice || !value || choice.disabled) return;

          choice.checked = true;
          variantInput.value = choice.value;
          submitButton.disabled = false;
          submitButton.textContent = `Add ${choice.dataset.giftCardPrice} gift card`;

          dots.forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          if (shouldScroll && mobileQuery.matches) {
            rail?.scrollTo({
              left: value.offsetLeft - (rail.clientWidth - value.offsetWidth) / 2,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        };

        const selectCentredChoice = () => {
          if (!mobileQuery.matches || !rail) return;

          const railCentre = rail.getBoundingClientRect().left + rail.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          values.forEach((value, index) => {
            if (choices[index]?.disabled) return;
            const bounds = value.getBoundingClientRect();
            const distance = Math.abs(bounds.left + bounds.width / 2 - railCentre);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          setActiveChoice(closestIndex);
        };

        choices.forEach((choice, index) => {
          choice.addEventListener('change', () => {
            if (!choice.checked) return;
            setActiveChoice(index, true);
          });
        });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => setActiveChoice(index, true));
        });

        rail?.addEventListener('scroll', () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(selectCentredChoice);
        }, { passive: true });

        requestAnimationFrame(() => {
          const initialIndex = Math.max(0, choices.findIndex((choice) => choice.checked));
          setActiveChoice(initialIndex);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["echo-gifting-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('echo-gifting-hub-carousel')) {
    customElements.define('echo-gifting-hub-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        const rail = this.querySelector('[data-gifting-rail]');
        const cards = [...this.querySelectorAll('[data-gifting-card]')];
        const dots = [...this.querySelectorAll('[data-gifting-dot]')];
        const mobileQuery = window.matchMedia('(max-width: 749px)');
        let scrollFrame;

        const setActiveCard = (index, shouldScroll = false) => {
          const card = cards[index];
          if (!card) return;

          cards.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
          dots.forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          if (shouldScroll && mobileQuery.matches) {
            rail?.scrollTo({
              left: card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        };

        const highlightCentredCard = () => {
          if (!mobileQuery.matches || !rail) return;

          const railCentre = rail.getBoundingClientRect().left + rail.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          cards.forEach((card, index) => {
            const bounds = card.getBoundingClientRect();
            const distance = Math.abs(bounds.left + bounds.width / 2 - railCentre);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          setActiveCard(closestIndex);
        };

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => setActiveCard(index, true));
        });

        rail?.addEventListener('scroll', () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(highlightCentredCard);
        }, { passive: true });

        requestAnimationFrame(() => setActiveCard(0));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["echo-materials-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('echo-materials-guide')) {
    customElements.define(
      'echo-materials-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.details = Array.from(this.querySelectorAll('[data-material-detail]'));
          this.media = Array.from(this.querySelectorAll('[data-material-media]'));

          this.details.forEach((detail) => {
            detail.addEventListener('toggle', () => {
              if (!detail.open) return;

              this.details.forEach((otherDetail) => {
                if (otherDetail !== detail) otherDetail.open = false;
              });

              this.media.forEach((mediaItem) => {
                mediaItem.classList.toggle('is-active', mediaItem.dataset.materialMedia === detail.dataset.materialDetail);
              });
            });
          });

          this.addEventListener('shopify:block:select', (event) => {
            const detail = event.target.closest('[data-material-detail]');
            if (detail) detail.open = true;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-wrapping-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseGiftChooser = (purchase) => {
      if (purchase.dataset.giftChooserReady === 'true') return;

      const form = purchase.querySelector('.echo-gift-wrapping__form');
      const variantInput = purchase.querySelector('[data-gift-variant-input]');
      const desktopChoices = [...purchase.querySelectorAll('[data-gift-choice]')];
      const selectedImages = [...purchase.querySelectorAll('[data-gift-image]')];
      const selectedThumbs = [...purchase.querySelectorAll('[data-gift-thumb]')];
      const selectedTitle = purchase.querySelector('[data-gift-selected-title]');
      const dialog = purchase.querySelector('[data-gift-dialog]');
      const openButton = purchase.querySelector('[data-gift-open]');
      const closeButton = purchase.querySelector('[data-gift-close]');
      const gallery = purchase.querySelector('[data-gift-gallery]');
      const slides = [...purchase.querySelectorAll('[data-gift-slide]')];
      const tabs = [...purchase.querySelectorAll('[data-gift-tab]')];
      const counter = purchase.querySelector('[data-gift-counter]');
      const confirmButton = purchase.querySelector('[data-gift-confirm]');
      const stickyBar = purchase.querySelector('[data-gift-sticky]');
      const stickyTitles = [...purchase.querySelectorAll('[data-gift-sticky-title], [data-gift-sticky-mobile-title]')];
      const primaryAction = purchase.querySelector('[data-gift-primary-action]');
      const footer = document.querySelector('.shopify-section--footer');
      const cartDrawer = document.querySelector('cart-drawer');

      if (!form || !variantInput || !dialog || !gallery || slides.length === 0) return;

      let pendingIndex = Math.max(0, slides.findIndex((slide) => slide.dataset.giftSlide === variantInput.value));
      let scrollFrame;
      let stickyArmed = false;
      let controlsVisible = false;
      let footerVisible = false;
      let wrappingAdded = false;
      let stickyScrollFrame;

      const updateSticky = () => {
        if (!stickyBar) return;

        const shouldShow = stickyArmed
          && !controlsVisible
          && !footerVisible
          && !dialog.open
          && !cartDrawer?.hasAttribute('open')
          && !wrappingAdded;

        stickyBar.classList.toggle('is-visible', shouldShow);
        stickyBar.setAttribute('aria-hidden', String(!shouldShow));
      };

      const applySelection = (index) => {
        const slide = slides[index];
        if (!slide) return;

        const variantId = slide.dataset.giftSlide;
        const title = slide.dataset.giftTitle;
        variantInput.value = variantId;
        selectedTitle.textContent = title;
        stickyTitles.forEach((stickyTitle) => { stickyTitle.textContent = title; });

        desktopChoices.forEach((choice) => {
          choice.setAttribute('aria-pressed', String(choice.dataset.giftChoice === variantId));
        });
        selectedImages.forEach((image) => image.classList.toggle('is-active', image.dataset.giftImage === variantId));
        selectedThumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.giftThumb === variantId));
      };

      const updatePending = (index) => {
        pendingIndex = Math.max(0, Math.min(index, slides.length - 1));
        const slide = slides[pendingIndex];
        tabs.forEach((tab, tabIndex) => tab.setAttribute('aria-selected', String(tabIndex === pendingIndex)));
        counter.textContent = `${pendingIndex + 1} of ${slides.length}`;
        confirmButton.textContent = `Choose ${slide.dataset.giftTitle}`;
      };

      const scrollToPending = (behavior = 'smooth') => {
        gallery.scrollTo({ left: gallery.clientWidth * pendingIndex, behavior });
      };

      desktopChoices.forEach((choice) => {
        choice.addEventListener('click', () => {
          const index = slides.findIndex((slide) => slide.dataset.giftSlide === choice.dataset.giftChoice);
          if (index >= 0) applySelection(index);
        });
      });

      openButton?.addEventListener('click', () => {
        const currentIndex = slides.findIndex((slide) => slide.dataset.giftSlide === variantInput.value);
        updatePending(currentIndex >= 0 ? currentIndex : 0);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        updateSticky();
        requestAnimationFrame(() => scrollToPending('auto'));
      });

      closeButton?.addEventListener('click', () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        updateSticky();
      });

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          updatePending(index);
          scrollToPending();
        });
      });

      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          if (gallery.clientWidth > 0) updatePending(Math.round(gallery.scrollLeft / gallery.clientWidth));
        });
      }, { passive: true });

      confirmButton?.addEventListener('click', () => {
        applySelection(pendingIndex);
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        updateSticky();
      });

      dialog.addEventListener('close', updateSticky);
      dialog.addEventListener('cancel', () => queueMicrotask(updateSticky));

      if (stickyBar && primaryAction) {
        const syncStickyPosition = () => {
          cancelAnimationFrame(stickyScrollFrame);
          stickyScrollFrame = requestAnimationFrame(() => {
            const actionRect = primaryAction.getBoundingClientRect();
            const footerRect = footer?.getBoundingClientRect();

            controlsVisible = actionRect.top < window.innerHeight && actionRect.bottom > 0;
            if (actionRect.top < window.innerHeight) stickyArmed = true;
            footerVisible = Boolean(footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0);
            updateSticky();
          });
        };

        const stickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === primaryAction) {
              controlsVisible = entry.isIntersecting;
              if (entry.isIntersecting) stickyArmed = true;
            }

            if (entry.target === footer) footerVisible = entry.isIntersecting;
          });
          updateSticky();
        });

        stickyObserver.observe(primaryAction);
        if (footer) stickyObserver.observe(footer);

        window.addEventListener('scroll', syncStickyPosition, { passive: true });
        window.addEventListener('resize', syncStickyPosition, { passive: true });
        form.addEventListener('variant:add', () => {
          wrappingAdded = true;
          updateSticky();
        });

        if (cartDrawer) {
          new MutationObserver(updateSticky).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
        }

        syncStickyPosition();
      }

      applySelection(pendingIndex);
      updatePending(pendingIndex);
      updateSticky();
      purchase.dataset.giftChooserReady = 'true';
    };

    const initialiseAllGiftChoosers = (root = document) => {
      root.querySelectorAll('.echo-gift-wrapping__purchase').forEach(initialiseGiftChooser);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAllGiftChoosers());
    } else {
      initialiseAllGiftChoosers();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAllGiftChoosers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const initializeEchoCampaignHeroes = (scope = document) => {
    const carousels = scope.querySelectorAll('[data-echo-campaign]:not([data-echo-initialized])');

    carousels.forEach((carousel) => {
      carousel.setAttribute('data-echo-initialized', '');

      const shell = carousel.closest('[data-echo-campaign-shell]');
      const firstImage = carousel.querySelector('.slideshow__slide.is-selected img');
      const mobileAction = carousel.querySelector('[data-echo-mobile-action]');
      const mobileActionCurrent = mobileAction?.querySelector('[data-echo-mobile-action-current]');
      const mobileActionNext = mobileAction?.querySelector('[data-echo-mobile-action-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeSlide = carousel.selectedCell;
      let actionResetFrame;
      let actionTimer;
      let headingRevealFrame;
      let heroReady = false;
      let panRequest = 0;

      const finishMobileActionTransition = () => {
        if (!mobileAction || !mobileActionCurrent || !mobileActionNext) {
          return;
        }

        clearTimeout(actionTimer);
        mobileAction.setAttribute('data-echo-action-resetting', '');

        if (mobileActionNext.textContent) {
          mobileActionCurrent.textContent = mobileActionNext.textContent;
        }

        mobileActionNext.textContent = '';
        mobileAction.removeAttribute('data-echo-action-changing');
        cancelAnimationFrame(actionResetFrame);
        actionResetFrame = requestAnimationFrame(() => mobileAction.removeAttribute('data-echo-action-resetting'));
      };

      const updateMobileAction = (slide, animate = true) => {
        const source = slide?.querySelector('.echo-hero__mobile-footer .button');

        if (!source || !mobileAction || !mobileActionCurrent || !mobileActionNext) {
          return;
        }

        if (mobileAction.hasAttribute('data-echo-action-changing')) {
          finishMobileActionTransition();
        }

        const label = source.textContent.trim();
        const href = source.getAttribute('href');

        if (!label) {
          return;
        }

        if (href) {
          mobileAction.setAttribute('href', href);
        } else {
          mobileAction.removeAttribute('href');
        }

        mobileAction.setAttribute('aria-label', label);

        if (!animate || reducedMotion.matches || mobileActionCurrent.textContent.trim() === label) {
          mobileActionCurrent.textContent = label;
          mobileActionNext.textContent = '';
          mobileAction.removeAttribute('data-echo-action-changing');
          return;
        }

        mobileActionNext.textContent = label;
        mobileAction.setAttribute('data-echo-action-changing', '');
        clearTimeout(actionTimer);
        actionTimer = setTimeout(finishMobileActionTransition, 260);
      };

      const restartSlidePan = async (slide) => {
        const request = ++panRequest;
        const picture = slide?.querySelector('.content-over-media > picture');
        const image = picture?.querySelector('img');

        if (!picture || !image) {
          return;
        }

        slide.removeAttribute('data-echo-pan-active');

        if (!image.complete) {
          await new Promise((resolve) => {
            const complete = () => {
              image.removeEventListener('load', complete);
              image.removeEventListener('error', complete);
              resolve();
            };

            image.addEventListener('load', complete);
            image.addEventListener('error', complete);
          });
        }

        if (!image.naturalWidth) {
          return;
        }

        try {
          await image.decode();
        } catch {
        }

        if (request !== panRequest || activeSlide !== slide) {
          return;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (request === panRequest && activeSlide === slide && slide.classList.contains('is-selected')) {
              slide.setAttribute('data-echo-pan-active', '');
            }
          });
        });
      };

      const restartMobileHeading = () => {
        if (!shell) {
          return;
        }

        cancelAnimationFrame(headingRevealFrame);
        shell.removeAttribute('data-echo-heading-reveal');
        headingRevealFrame = requestAnimationFrame(() => shell.setAttribute('data-echo-heading-reveal', ''));
      };

      const activateSlide = (slide, restartHeading = false) => {
        if (!slide) {
          return;
        }

        carousel.querySelectorAll('.slideshow__slide[data-echo-active]').forEach((item) => {
          item.removeAttribute('data-echo-active');
        });

        activeSlide = slide;
        activeSlide.setAttribute('data-echo-active', '');

        if (heroReady && restartHeading) {
          restartMobileHeading();
        }
      };

      const reveal = () => {
        heroReady = true;
        shell?.setAttribute('data-echo-ready', '');
        carousel.setAttribute('data-echo-ready', '');
        activateSlide(carousel.selectedCell, true);
        updateMobileAction(activeSlide, false);
        restartSlidePan(activeSlide);
      };

      if (!firstImage || firstImage.complete) {
        requestAnimationFrame(reveal);
      } else {
        firstImage.addEventListener('load', reveal, { once: true });
      }

      carousel.addEventListener('carousel:change', (event) => {
        event.detail.cell.removeAttribute('data-echo-pan-active');
        updateMobileAction(event.detail.cell);
        activateSlide(event.detail.cell, true);
      });

      carousel.addEventListener('carousel:settle', (event) => {
        if (activeSlide !== event.detail.cell) {
          activateSlide(event.detail.cell, true);
        }

        carousel.querySelectorAll('.slideshow__slide[data-echo-pan-active]').forEach((slide) => {
          if (slide !== activeSlide) {
            slide.removeAttribute('data-echo-pan-active');
          }
        });

        if (!activeSlide.hasAttribute('data-echo-pan-active')) {
          restartSlidePan(activeSlide);
        }
      });

      const autoplayToggle = carousel.querySelector('[data-echo-autoplay-toggle]');
      const player = carousel.player;

      if (!autoplayToggle || !player) {
        return;
      }

      const desktopControls = window.matchMedia('(min-width: 700px)');
      let manuallyPaused = false;

      const updateToggle = (paused) => {
        autoplayToggle.toggleAttribute('data-echo-paused', paused);
        autoplayToggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        autoplayToggle.setAttribute('aria-label', paused ? autoplayToggle.dataset.playLabel : autoplayToggle.dataset.pauseLabel);
      };

      const pause = () => {
        manuallyPaused = true;
        player.stop();
        updateToggle(true);
      };

      const play = () => {
        manuallyPaused = false;
        player.start();
        updateToggle(false);
      };

      autoplayToggle.hidden = !desktopControls.matches;

      autoplayToggle.addEventListener('click', () => {
        if (!desktopControls.matches) {
          return;
        }

        if (autoplayToggle.hasAttribute('data-echo-paused')) {
          play();
        } else {
          pause();
        }
      });

      carousel.addEventListener('focusin', (event) => {
        if (desktopControls.matches && event.target !== autoplayToggle && !manuallyPaused) {
          player.pause();
        }
      });

      carousel.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (desktopControls.matches && !carousel.contains(document.activeElement) && !manuallyPaused) {
            player.resume();
          }
        });
      });

      carousel.addEventListener('carousel:settle', () => {
        if (desktopControls.matches && carousel.contains(document.activeElement) && document.activeElement !== autoplayToggle && !manuallyPaused) {
          player.pause();
        }
      });

      player.addEventListener('player:pause', () => {
        carousel.style.setProperty('--slideshow-progress-play-state', 'paused');
      });

      player.addEventListener('player:resume', () => {
        carousel.style.setProperty('--slideshow-progress-play-state', 'running');
      });

      desktopControls.addEventListener('change', (event) => {
        autoplayToggle.hidden = !event.matches;

        if (!event.matches) {
          play();
        }
      });

      updateToggle(false);
    });
  };

  const loadEchoCampaignHeroes = (scope = document) => {
    customElements.whenDefined('slideshow-carousel').then(() => initializeEchoCampaignHeroes(scope));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadEchoCampaignHeroes());
  } else {
    loadEchoCampaignHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => loadEchoCampaignHeroes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('echo-testimonials')) {
    customElements.define('echo-testimonials', class extends HTMLElement {
      connectedCallback() {
        const carousel = this.querySelector('testimonial-carousel');
        const currentReview = this.querySelector('[data-testimonial-current]');

        if (!carousel || !currentReview) return;

        carousel.addEventListener('carousel:change', (event) => {
          currentReview.textContent = event.detail.index + 1;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
